import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// BS: reset scroll to top on every route change — navigating via footer/header
// links otherwise keeps the previous page's scroll position.
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
